import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="rk-footer">
      <div className="footer-grid">
        {/* Brand */}
        <div>
          <Link to="/" className="rk-logo" style={{ marginBottom: 0 }}>
            <div className="rk-logo-icon">
              <i className="bi bi-shield-fill"></i>
            </div>
            <div>
              <span className="rk-logo-text">RAKSHA</span>
              <span className="rk-logo-sub">Ireland</span>
            </div>
          </Link>
          <p className="footer-brand-tagline">
            A verified community alert and support app for Ireland. Not a replacement for 112/999.
          </p>
          <div className="footer-socials">
            <a href="mailto:support@rakshaireland.com" className="footer-social" aria-label="Email RAKSHA support">
              <i className="bi bi-envelope"></i>
            </a>
          </div>
        </div>

        {/* The App */}
        <div>
          <p className="footer-col-title">The App</p>
          <div className="footer-col-links">
            <Link to="/#waitlist">Join the Waitlist</Link>
            <Link to="/how-it-works">How It Works</Link>
            <Link to="/features">Features</Link>
            <Link to="/safety">Safety &amp; Trust</Link>
            <Link to="/responders">Helping Others</Link>
            <Link to="/blog">Blog</Link>
          </div>
        </div>

        {/* Legal */}
        <div>
          <p className="footer-col-title">Legal &amp; Info</p>
          <div className="footer-col-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>

        {/* Contact */}
        <div>
          <p className="footer-col-title">Get in Touch</p>
          <div className="footer-contact-row">
            <i className="bi bi-envelope-fill"></i>
            <a href="mailto:support@rakshaireland.com">support@rakshaireland.com</a>
          </div>
          <div className="footer-contact-row">
            <i className="bi bi-geo-alt-fill"></i>
            <span>Dublin, Ireland<br /><span style={{ fontSize: '0.8rem', opacity: 0.6 }}>Serving all of Ireland</span></span>
          </div>
          <div className="footer-contact-row" style={{ marginTop: 8 }}>
            <i className="bi bi-clock-fill"></i>
            <span>Support responses within 2 business days<br /><span style={{ fontSize: '0.8rem', opacity: 0.6 }}>Not a 24/7 emergency line — call 112 or 999</span></span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div style={{ marginBottom: 6 }}>
          <span style={{ display: 'inline-block', background: '#d32f2f', color: '#fff', padding: '2px 10px', borderRadius: 10, fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.06em', marginRight: 10 }}>
            ANDROID BETA
          </span>
          <span style={{ opacity: 0.75 }}>v1.0.0 · Made in Ireland</span>
        </div>
        © 2026 RAKSHA Ireland. All rights reserved. RAKSHA is a community-powered personal safety network and does not replace 112 / 999.
      </div>
    </footer>
  );
}
